import { api } from "./api";

  /**
   * 게시판 목록 조회
   * 
   * @returns resultCode, message, data
   */  
  export const getBoards = async () => {
    try {
      const res = await api().get("/boards");
      return res?.data;
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * 게시판 목록 조회
   * 
   * @returns resultCode, message, data
   */  
  export const getBoardsWithRootCategory = async () => {
      try {
        const res = await api().get("/boards-with-root-category");
        return res?.data;
      } catch (e) {
        console.log(e);
      }
    };